/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 07.07.25
 *
 */

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)


export function addLocalCalendarDays(timeMs, days) {
	return dayjs(timeMs).add(days, 'day').valueOf()
}

export function toUserLocalTimeFormatted(timeMs, format = 'YYYY-MM-DD HH:mm') {
	return dayjs(timeMs).format(format)
}
